import { NavigationUtilitiesService } from "@common/route/navigation-utilities.service";
import { AuthorisationService } from "./authorisation.service";

export function initialiseNavigationAccessVerificationCallback(authService: AuthorisationService, navUtilitiesService: NavigationUtilitiesService) {
    return () => {
        navUtilitiesService.setAccessVerificationCallback(authService.promiseToVerifyAccess.bind(authService));
    };
}
